import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "d-flex flex-column min-vh-100 bg-light" }
const _hoisted_2 = { class: "bg-white border-bottom py-4" }
const _hoisted_3 = { class: "container d-flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" TekPanel ")
const _hoisted_5 = { class: "d-flex align-items-center gap-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Hakkında")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Destek")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Gizlilik")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Giriş Yap")
const _hoisted_10 = { class: "container py-8 py-lg-10 flex-grow-1" }
const _hoisted_11 = {
  class: "card shadow-sm mx-auto",
  style: {"max-width":"920px"}
}
const _hoisted_12 = { class: "card-body p-7 p-lg-10" }
const _hoisted_13 = { class: "fw-bolder text-dark mb-2" }
const _hoisted_14 = {
  key: 0,
  class: "text-gray-500 fs-5 mb-8"
}
const _hoisted_15 = { class: "bg-white border-top py-5" }
const _hoisted_16 = { class: "container d-flex flex-column flex-md-row justify-content-between align-items-center gap-2" }
const _hoisted_17 = { class: "text-gray-500 fs-7" }
const _hoisted_18 = { class: "d-flex gap-4" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Hakkında")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Destek")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Gizlilik Politikası")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/hakkinda",
          class: "fs-2 fw-bolder text-dark text-decoration-none"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/hakkinda",
            class: "text-gray-700 fw-semibold text-decoration-none d-none d-sm-inline"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/destek",
            class: "text-gray-700 fw-semibold text-decoration-none d-none d-sm-inline"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/gizlilik",
            class: "text-gray-700 fw-semibold text-decoration-none d-none d-sm-inline"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-sm btn-primary"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.title), 1),
          (_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.subtitle), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, "© " + _toDisplayString(_ctx.year) + " YYVZ LLC ", 1),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_router_link, {
            to: "/hakkinda",
            class: "text-gray-600 fs-7 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/destek",
            class: "text-gray-600 fs-7 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/gizlilik",
            class: "text-gray-600 fs-7 text-decoration-none"
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}